import { CombinedGraphQLErrors } from '@apollo/client';
import { getFirstNestJsGraphQLError } from '@pcg/graphql-kit';

/**
 * Toast-friendly description: the NestJS error key when present, else the
 * message. A message that opens with its own key in brackets
 * (`[QA_FIX_NOTE_REQUIRED] FIXED needs…`) was written to be read — the
 * convention QA and validation errors and the Fix Needed gate follow — so it
 * is shown instead, without the bracketed key.
 */
export const resolveGraphqlErrorDescription = (error: unknown): string => {
  const nestError = CombinedGraphQLErrors.is(error) ? getFirstNestJsGraphQLError(error) : null;
  const errKey = nestError?.extensions?.key;

  if (errKey) {
    const prefix = `[${String(errKey)}] `;

    return nestError.message.startsWith(prefix) ? nestError.message.slice(prefix.length) : String(errKey);
  }

  return error instanceof Error ? error.message : 'Unknown error';
};
